import type {FlagProps} from 'platform/components';
import {match} from 'ts-pattern';

import type {NewVehicleLabelGroup} from '../../utils/newVehicleLabels';

export function getNewVehicleEnumColorScheme(
  group: NewVehicleLabelGroup,
  value: string
): FlagProps['colorScheme'] {
  return (
    match<[NewVehicleLabelGroup, string], FlagProps['colorScheme']>([group, value])
      .with(['orderStatus', 'ordered'], ['orderStatus', 'in_production'], () => 'blue')
      .with(['orderStatus', 'in_transit'], () => 'teal')
      .with(['orderStatus', 'arrived'], ['orderStatus', 'ready_for_handover'], () => 'green')
      .with(['orderStatus', 'handed_over'], () => 'purple')
      .with(['orderStatus', 'cancelled'], () => 'red')
      .with(['publicationStatus', 'active'], ['publicationStatus', 'online'], () => 'green')
      .with(['publicationStatus', 'draft'], () => 'orange')
      // Same colours as the BE model year status flags in the catalogue grid; draft and archived stay neutral.
      .with(['modelYearStatus', 'active'], () => 'green')
      .with(['priceValidity', 'valid'], () => 'green')
      .with(['priceValidity', 'expired'], () => 'orange')
      .with(['packageStatus', 'active'], () => 'green')
      .with(['fitStage', 'factory'], () => 'blue')
      .with(['fitStage', 'dealer'], () => 'teal')
      .with(['inclusion', 'STANDARD'], () => 'green')
      .with(['commercialAvailability', 'orderable'], () => 'green')
      .with(['commercialAvailability', 'preview'], () => 'blue')
      .with(['commercialAvailability', 'sold_out'], () => 'red')
      .otherwise(() => 'neutral')
  );
}
